import { global_hooks } from 'src/globals';

global_hooks.on('init', init);

const activate_point = get_activate_point();

function init() {
	if (disable()) return;

	// disable filter if needed
	// let disable = global_hooks.apply_filter('header/sticky/disable', disable_sticky());
	// if (disable) return;
	// global_hooks.add_filter('header/sticky/disable', () => true);

	document.addEventListener('scroll', load_header_sticky_scripts, {
		passive: true,
	});
}

function load_header_sticky_scripts() {
	if (window.scrollY < activate_point) return;
	document.removeEventListener('scroll', load_header_sticky_scripts);
	import('./header_sticky');
}

function get_activate_point() {
	if (!ff?.settings?.header_sticky_settings?.activate_point) {
		return 500;
	}
	return parseInt(ff.settings.header_sticky_settings.activate_point);
}

function disable() {
	if (!ff?.settings?.enable_header_sticky) return true;
	if (!document.querySelector('.elementor-location-header')) return true;
	if (document.body.classList.contains('disable_header_sticky')) return true;
	return false;
}
